export interface FirestoreDocument {
   id: string
   created_at: Date
   updated_at: Date
   updated_by: string
   is_deleted: boolean
}

export type DocumentData<T extends FirestoreDocument> = Omit<T, keyof FirestoreDocument>

export const dexieFirestoreDocument = "id"
